var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "clipboard-quick-insert" },
    [
      _c(
        "button",
        {
          ref: "trigger",
          class: [
            "clipboard-quick-insert__trigger",
            _vm.triggerClass,
            { active: _vm.open },
          ],
          attrs: {
            id: _vm.triggerId,
            type: "button",
            title: "Insert from Clipboard",
            disabled: _vm.disabled,
            "aria-haspopup": "dialog",
            "aria-expanded": _vm.open ? "true" : "false",
          },
          on: { click: _vm.onTriggerClick },
        },
        [
          _vm._t("icon", function () {
            return [
              _c(
                "svg",
                {
                  staticClass: "clipboard-quick-insert__icon",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("rect", {
                    attrs: {
                      width: "8",
                      height: "4",
                      x: "8",
                      y: "2",
                      rx: "1",
                      ry: "1",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                    },
                  }),
                ]
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "clipboard-quick-insert-fade" } }, [
        _vm.open
          ? _c(
              "div",
              {
                ref: "flyout",
                staticClass: "clipboard-quick-insert__flyout",
                style: _vm.flyoutStyle,
                attrs: {
                  role: "dialog",
                  "aria-labelledby": "clipboard-quick-insert-title",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "clipboard-quick-insert__header" }, [
                  _c(
                    "div",
                    { staticClass: "clipboard-quick-insert__header-title" },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "clipboard-quick-insert__header-icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("rect", {
                            attrs: {
                              width: "8",
                              height: "4",
                              x: "8",
                              y: "2",
                              rx: "1",
                              ry: "1",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "clipboard-quick-insert__header-label",
                          attrs: { id: "clipboard-quick-insert-title" },
                        },
                        [_vm._v("Insert from Clipboard")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "clipboard-quick-insert__open-all",
                      attrs: { type: "button" },
                      on: { click: _vm.onOpenAll },
                    },
                    [_vm._v("\n          Open all\n        ")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "clipboard-quick-insert__list" },
                  [
                    _vm.loading
                      ? _c(
                          "div",
                          { staticClass: "clipboard-quick-insert__status" },
                          [_vm._v("\n          Loading…\n        ")]
                        )
                      : _vm.loadError
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "clipboard-quick-insert__status clipboard-quick-insert__status--error",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.loadError) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm.displayItems.length === 0
                      ? _c(
                          "div",
                          { staticClass: "clipboard-quick-insert__status" },
                          [_vm._v("\n          Nothing saved yet.\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.displayItems, function (item) {
                      return _c(
                        "button",
                        {
                          key: item.id,
                          staticClass: "clipboard-quick-insert__item",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.onSelectItem(item)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "clipboard-quick-insert__item-head",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "clipboard-quick-insert__item-sparkles",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "aria-hidden": "true",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "M20 3v4" } }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "M22 5h-4" } }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "M4 17v2" } }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "M5 18H3" } }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.typeLabel(item.type))),
                              ]),
                              _vm._v(" "),
                              _vm.itemHasTitle(item)
                                ? [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v("·")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "clipboard-quick-insert__item-title",
                                      },
                                      [_vm._v(_vm._s(item.title))]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "clipboard-quick-insert__item-preview",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.previewContent(item)) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }